<div>
  <div class="font-weight-bold text-dark font-size-24">900</div>
  <div>Completed</div>
  <x-chartist [data]="chartData" [type]="'Line'" [options]="chartOptions" class="height-200 ct-hidden-points">
  </x-chartist>
</div>